<template>
  <section class="main-container">
    <Top></Top>
    <div class="">
      <router-view :key="key"></router-view>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Top from '@/components/top.vue'
import Footer from '@/components/footer.vue'
export default {
  computed: {
    key () {
      // console.log('app', this.$route)
      return this.$route.name ? this.$route.name + new Date() : this.$route + new Date()
    }
  },
  components: {
    Top,
    Footer
  }
}
</script>

<style>

</style>
